import { BehaviorSubject } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export const CHECKED_EMAIL_KEY = 'checkedEmail';

@Injectable({
  providedIn: 'root',
})
export class CheckEmailService {
  currentEmail = new BehaviorSubject('');
  currentEmail$ = this.currentEmail.asObservable();

  private emailExistenceSubject = new BehaviorSubject(null);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  public emailExistence$ = this.emailExistenceSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private readonly platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      const checkedEmail = localStorage.getItem(CHECKED_EMAIL_KEY);
      if (checkedEmail) {
        this.currentEmail.next(checkedEmail);
      }
    }
  }

  clearEmail() {
    localStorage.removeItem(CHECKED_EMAIL_KEY);
    this.currentEmail.next('');
  }

  saveEmail(enteredEmail: string) {
    localStorage.setItem(CHECKED_EMAIL_KEY, enteredEmail);
    this.currentEmail.next(enteredEmail);
  }

  changeEmailExistenceStatus(status) {
    this.emailExistenceSubject.next(status);
  }
}
